import { FollowType } from "@markit/common.types";
import { Mixpanel } from "../context/AnalyticsService";
import { getUserData } from "./FirebaseUtils";
import { followUser } from "./FollowUser";

const MARKIT_ACCOUNT_ID = "J1qrWf8y9ARt82JhMERusyLHuar2";

// Plain-text mirror of WeeklyUpdatesDisclosure's JSX
export const WEEKLY_UPDATES_DISCLOSURE_TEXT =
  "By creating an account, you'll receive our weekly text updates with product tips and more (we ARE a texting platform after all). Msg&Data rates may apply. Text STOP to opt out.";

// Shared by every creator sign-up path (email/password on LoginWelcome, Google
// on LoginOnboardingAccountDetails) - phone number is required on sign-up
// specifically so every creator opts into weekly community text updates.
export const optInToWeeklyCommunityUpdates = async (
  uid: string,
  fullName: string,
  phoneNumber: string,
  mixpanel: Mixpanel,
  origin: string
) => {
  const markitaiAccountData = await getUserData(MARKIT_ACCOUNT_ID);
  if (markitaiAccountData) {
    await followUser({
      userPhone: phoneNumber,
      userFullName: fullName,
      userToFollow: markitaiAccountData,
      uid: "",
      followType: FollowType.PROFILE,
      answers: undefined,
      suppressResponse: true,
    });
    mixpanel.track("Webapp: Opted In to Weekly Community Updates", {
      uid: uid,
      origin: origin,
      phoneNumber: phoneNumber,
      fullName: fullName,
      disclosureText: WEEKLY_UPDATES_DISCLOSURE_TEXT,
    });
  }
};
